var React = require('react');

function SDCSinglePage18N (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.42215,3.13907,12.90208.583A1.98767,1.98767,0,0,0,11.50248,0H4.20876A2.248,2.248,0,0,0,2,2.24994v12.4967A2.25079,2.25079,0,0,0,4.21945,17h9.57081A2.24881,2.24881,0,0,0,16,14.75007V4.55211A1.98271,1.98271,0,0,0,15.42215,3.13907ZM11.49567,1.5a.52515.52515,0,0,1,.34063.13866L14.35636,4.1947a.492.492,0,0,1,.13738.31786H11.49567ZM13.77954,15.5H4.2302a.74555.74555,0,0,1-.731-.75V2.24652A.74285.74285,0,0,1,4.21945,1.5H9.99651V5.26254a.75.75,0,0,0,.74958.75h3.75472v8.74093a.743.743,0,0,1-.72129.74659Z","fill":"var(--iconFill, #464646)"}));
}

SDCSinglePage18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCSinglePage18N;

SDCSinglePage18N.default = SDCSinglePage18N;
